import React from 'react';
import { motion } from 'framer-motion';
import { Ear, Search, Compass, HeartHandshake } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function CadouProcess() {
  const steps = [{
    icon: Ear,
    title: 'Ascult și înțeleg situația ta',
    desc: 'Îmi povestești ce simți, ce te preocupă și ce ai încercat până acum. Eu ascult cu atenție, fără judecată și fără grabă.'
  }, {
    icon: Search,
    title: 'Identificăm ce te blochează',
    desc: 'Împreună descoperim ce tipare se repetă în viața ta și ce credințe din subconștient te țin pe loc fără să îți dai seama.'
  }, {
    icon: Compass,
    title: 'Stabilim următorul pas concret',
    desc: 'Îți dau o recomandare clară: ce poți face începând de azi, indiferent dacă alegi să lucrezi cu mine sau nu.'
  }, {
    icon: HeartHandshake,
    title: 'Tu decizi ce urmează',
    desc: 'Dacă simți că e potrivire, îți prezint opțiunile din Academie. Dacă nu, pleci cu claritate și un plan pe care îl poți aplica singură.'
  }];
  return <section className="py-20 lg:py-32 bg-brand-cream relative overflow-hidden" data-id="element-322">
      <div className="max-w-6xl mx-auto px-6" data-id="element-323">
        <SectionHeading title="Cum decurge sesiunea ta gratuită" data-id="element-324" />

        <div className="relative grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-325">
          {steps.map((step, idx) => {
          const Icon = step.icon;
          return <motion.div key={idx} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: idx * 0.12
          }} className="relative bg-white rounded-3xl p-7 shadow-sm border border-brand-text/5 hover:shadow-warm transition-shadow" data-id="element-326">
                {/* Step number badge */}
                <div className="absolute -top-4 -right-4 w-12 h-12 bg-brand-purple text-white rounded-full flex items-center justify-center font-heading font-bold text-lg shadow-warm" data-id="element-327">
                  {idx + 1}
                </div>

                <div className="w-14 h-14 bg-brand-gold/10 rounded-2xl flex items-center justify-center mb-5 text-brand-gold" data-id="element-328">
                  <Icon className="w-7 h-7" data-id="element-329" />
                </div>

                <h3 className="font-bold text-xl text-brand-text mb-3" data-id="element-330">
                  {step.title}
                </h3>
                <p className="text-brand-textSec leading-relaxed" data-id="element-331">
                  {step.desc}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto text-center mb-12 p-6 bg-brand-purple/5 border-l-4 border-brand-purple rounded-r-xl" data-id="element-332">
          <p className="font-subtitle italic text-xl text-brand-text leading-relaxed" data-id="element-333">
            Fără vânzare agresivă. Fără presiune. Doar o conversație caldă,
            sinceră, din care pleci cu mai multă claritate decât ai venit.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-334">
          <CTAButton data-id="element-335" />
        </motion.div>
      </div>
    </section>;
}